import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Card, Row, Col, Radio, Avatar, Space } from 'antd';

import { getPublicSiteImageSrc } from '../../common/utils/AppUtils'


const CardsOne = ({ isBroker = '', partnerType = '', handleRadioSelection }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1366);
  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1366);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
      <>
        <div>
          <Fragment>
            <Typography.Title level={2} className="cards-heading">
              <Space>
                <Avatar 
                  style={{ backgroundColor: '#074079' }} 
                  size={{ xs: 32, sm: 32, md: 36, lg: 36, xl: 36, xxl: 36}}
                  aria-label="Step 1"
                >
                  1
                </Avatar> 
                <span className="avatar-text" id="broker-question-heading">Are you an Anthem-Appointed Broker ?</span>
              </Space>
            </Typography.Title>
          </Fragment>
        </div>
        <Row gutter={{sm: 16, md: 24}}>
          <Col span={8}>
            <Radio.Group 
              name="isBroker" 
              onChange={handleRadioSelection} 
              value={isBroker}
              role="radiogroup"
              aria-labelledby="broker-question-heading"
            >
              <Space size="large">
                <Row 
                  className="qna-radiobutton qna-big-card" 
                  type="flex" 
                  justify="center" 
                  align="middle"
                >
                  <Col xs={{offset: 4, span: 12}} sm={{offset: 4, span: 12}} md={{offset: 8, span: 12}}>
                    <img
                        src={getPublicSiteImageSrc('broker.svg')}
                        alt="Anthem-Appointed Broker icon"
                        className="qna_image"
                        aria-hidden="true"
                      />
                  </Col>
                  <Col offset={4} span={20}>
                    <Radio value={true} aria-label="Yes, I am an Anthem-Appointed Broker">
                        <span className='qna-value'>Yes</span>
                    </Radio>
                  </Col>
                </Row>
                <Row 
                  className="qna-radiobutton qna-big-card" 
                  type="flex" 
                  justify="center" 
                  align="middle"
                >
                  <Col xs={{offset: 4, span: 12}} sm={{offset: 4, span: 12}} md={{offset: 8, span: 12}}>
                    <img
                        src={getPublicSiteImageSrc('no_broker.svg')}
                        alt="Not an Anthem-Appointed Broker icon"
                        className="qna_image"
                        aria-hidden="true"
                      />
                  </Col>
                  <Col offset={4} span={20}>
                    <Radio value={false} aria-label="No, I am not an Anthem-Appointed Broker">
                        <span className='qna-value'>No</span>
                    </Radio>
                  </Col>
                </Row>
              </Space>
            </Radio.Group>
          </Col>
        </Row>

        { isBroker === false && (
          <div className='secondary-qna'>
            <div className="ant-result-title">
              <Typography.Title level={2} className="cards-heading" id="partner-role-heading">Choose Your Partner Role</Typography.Title>
            </div>
            <div className="ant-result-title">
            <Typography.Paragraph className="cards-heading-secondary">What role best describes who you are?</Typography.Paragraph>
          </div>
            <Radio.Group 
              name="partnerType" 
              onChange={handleRadioSelection} 
              value={partnerType}
              role="radiogroup"
              aria-labelledby="partner-role-heading"
            >
              <Row className="partnerType-card-row" gutter={[{sm: 16, md: 24}, 24]}>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <Card
                    className="partnerType-card"
                  >
                    <Row alignItems="center" gutter={[{ sm: 0, md: 16}, { xs: 8, sm: 16, md: 24 }]}>
                      <Col span={12}>
                        <Radio
                          id="agency-radio"
                          className="partnerType_heading"
                          value="broker"
                          aria-describedby="agency-desc"
                        >
                          Agency
                        </Radio>
                      </Col>
                      <Col md={{ span: 6, offset: 6 }}  sm={{ span: 4, offset: 8 }}>
                        <img
                          src={getPublicSiteImageSrc("agency.svg")}
                          alt="Agency partner type icon"
                          className="image-partnerType"
                          aria-hidden="true"
                        />
                      </Col>
                      <Col span={24}>
                        <Typography.Paragraph id="agency-desc" className="partnerType-desc" ellipsis={ isMobile ? { rows: 3, expandable: false } : false}>
                        Select this role if you're an appointed broker or an entity that directly quotes, sells, and services Anthem's individual or group plans-without using third-party benefit administrator services. This option is designed for those who manage client interactions and want direct access to Anthem's offerings.
                        </Typography.Paragraph>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <Card
                    className="partnerType-card"
                  >
                    <Row alignItems="center" gutter={[16, { sm: 16, md: 24 }]}>
                      <Col span={12}>
                        <Radio
                          id="benadmin-radio"
                          className="partnerType_heading"
                          value="benadmin"
                          aria-describedby="benadmin-desc"
                        >
                          Benefit Administrator
                        </Radio>
                      </Col>
                      <Col md={{ span: 6, offset: 6 }}  sm={{ span: 4, offset: 8 }}>
                        <img
                          src={getPublicSiteImageSrc("benfit.svg")}
                          alt="Benefit Administrator partner type icon"
                          className="image-partnerType"
                          aria-hidden="true"
                        />
                      </Col>
                      <Col span={24}>
                        <Typography.Paragraph id="benadmin-desc" className="partnerType-desc" ellipsis={ isMobile ? { rows: 3, expandable: false } : false}>
                        Select this role if your firm provides administrative support for broker clients through a technology platform. This option enables brokers to connect directly with carriers for quoting, eligibility, enrollment, and other client management functions.
                        </Typography.Paragraph>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <Card
                    className="partnerType-card"
                  >
                    <Row alignItems="center" gutter={[16, { sm: 16, md: 24 }]}>
                      <Col span={12}>
                        <Radio
                          id="techplatform-radio"
                          className="partnerType_heading"
                          value="techplatform"
                          aria-describedby="techplatform-desc"
                        >
                          Technology Partner
                        </Radio>
                      </Col>
                      <Col md={{ span: 6, offset: 6 }}  sm={{ span: 4, offset: 8 }}>
                        <img
                            src={getPublicSiteImageSrc("techplatform.svg")}
                        alt="Technology Partner type icon"
                        className="image-partnerType"
                        aria-hidden="true"
                        />
                      </Col>
                      <Col span={24}>
                       <Typography.Paragraph id="techplatform-desc" className="partnerType-desc" ellipsis={ isMobile ? { rows: 3, expandable: false } : false}>
                       Select this role if your company develops direct carrier connection technology used by benefit administrators and other vendors.
                        </Typography.Paragraph>
                      </Col>
                    </Row>
                  </Card>
                </Col>                
              </Row>
            </Radio.Group>
          </div>
        )}
    </>
  );
};

export default CardsOne;
